import script from "./channelView.vue?vue&type=script&setup=true&lang=js"
export * from "./channelView.vue?vue&type=script&setup=true&lang=js"

import "./channelView.vue?vue&type=style&index=0&id=5cbced45&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cbced45"]])

export default __exports__